import React from 'react';

import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HandoffArtwork from 'marketing-website/components/modules/HandoffArtwork';
import ImageRightBlock from '../../components/modules/ImageRightBlock';

export default function Automated() {
  return (
    <PageWrap size="l">
      <Spacing size="m" sizeM="xl" type="padding" position="topBottom">
        <ImageRightBlock
          title="Design specs, automated"
          artwork={<HandoffArtwork />}
          buttonText="Learn more"
          copy={
            <span>
              Optimise your design-to-development process with our Handoff tool.
              <br />
              <br />
              With one click you can instantly download assets and generate CSS,
              Swift and Android XML code for your prototypes, which stays in
              sync with your most recent design changes.
            </span>
          }
          link="/features/handoff"
        />
      </Spacing>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/why-marvel/Automated.js